const STORAGE_KEY = 'shownPromoModals';

export function getShownPromoModals(): Set<string> {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return new Set(Array.isArray(parsed) ? parsed : []);
    }
  } catch (error) {
    console.error('Error reading shown promo modals:', error);
  }
  return new Set<string>();
}

export function saveShownPromoModals(modals: Set<string>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(modals)));
  } catch (error) {
    console.error('Error saving shown promo modals:', error);
  }
}

export function markPromoModalAsShown(modalKey: string): void {
  const shown = getShownPromoModals();
  shown.add(modalKey);
  saveShownPromoModals(shown);
}

export function isPromoModalShown(modalKey: string): boolean {
  const shown = getShownPromoModals();
  return shown.has(modalKey);
}

export interface PromoModalCheckResult {
  shouldShow: boolean;
  modalKey: string | null;
}

export function checkAndShowPromoModal(
  cellItem: {
    time: string;
    courtType?: string;
    bitrixCourtId?: string;
  },
  date: string,
  currentBasket: { [key: string]: any }
): PromoModalCheckResult {
  const time = cellItem.time;
  const hour = parseInt(time.split(':')[0], 10);
  const isWeekend = isWeekendDay(date);
  
  const COURT_ID_PADLE = [
    'c5230dbe-bde4-11ef-80cd-ac1f6bea5f2d',
    'c5230dd1-bde4-11ef-80cd-ac1f6bea5f2d',
    'cd33359d-bde4-11ef-80cd-ac1f6bea5f2d',
    '2336b85a-8400-11f0-80d2-ac1f6bea5f2d',
    '2336b86d-8400-11f0-80d2-ac1f6bea5f2d',
    '2b356290-8400-11f0-80d2-ac1f6bea5f2d',
  ];
  
  const isPadelCourt = cellItem.bitrixCourtId 
    ? COURT_ID_PADLE.includes(cellItem.bitrixCourtId)
    : cellItem.courtType?.toLowerCase().includes('padel');
  
  const COURT_ID_HARD2 = [
    '39df27c8-eb55-11e9-9ab5-382c4a64b65a',
    '4f0b42a8-eb55-11e9-9ab5-382c4a64b65a',
    '58234368-eb55-11e9-9ab5-382c4a64b65a',
    '05e09479-574c-11ec-80d6-ac1f6bb3f7d2',
  ];
  
  const isHardCourt = cellItem.bitrixCourtId
    ? COURT_ID_HARD2.includes(cellItem.bitrixCourtId)
    : cellItem.courtType?.toLowerCase().includes('хард') || cellItem.courtType?.toLowerCase().includes('hard');

  if (!isWeekend && isPadelCourt && hour >= 21 && hour < 23) {
    const modalKey = 'padel_weekday_modal';
    if (!isPromoModalShown(modalKey)) {
      return { shouldShow: true, modalKey };
    }
  }

  if (isWeekend && isPadelCourt && hour >= 10 && hour < 18) {
    const modalKey = 'padel_weekend_modal';
    if (!isPromoModalShown(modalKey)) {
      return { shouldShow: true, modalKey };
    }
  }

  if (isWeekend && isHardCourt && hour >= 14 && hour < 17) {
    const modalKey = 'hard_weekend_modal';
    if (!isPromoModalShown(modalKey)) {
      return { shouldShow: true, modalKey };
    }
  }

  return { shouldShow: false, modalKey: null };
}

function isWeekendDay(date: string): boolean {
  const d = new Date(date);
  const dayOfWeek = d.getDay();
  return dayOfWeek === 0 || dayOfWeek === 6;
}
